/**
 * Stub replacement for `@heyvr/sdk-ad-wonderland`'s HeyVRAd component.
 * Self-hosted build has no ad provider; this lets scenes that reference
 * the component still load and any callers that `getComponent(HeyVRAd)` work.
 *
 * Keep TypeName identical to the original so .wlp scene files don't need editing.
 */
import { Component, Property } from '@wonderlandengine/api';

export class HeyVRAd extends Component {
    static TypeName = 'hey-vr-ad';
    static Properties = {
        slug: Property.string(''),
        autoplay: Property.bool(false),
    };

    /** No-op API surface so existing callers (lobby-handler.js) don't crash. */
    showAd() { return Promise.resolve({ shown: false, reason: 'self-hosted: no ads' }); }
    play()   { return this.showAd(); }
}
